import React from 'react';
import { Result, Button } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Page error:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const chunkFailed = /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module/i.test(String(error?.message || error));
    return (
      <Result
        status="warning"
        title={chunkFailed ? 'A newer version of ASHR is available' : 'This page could not be displayed'}
        subTitle={chunkFailed ? 'Reload to continue.' : String(error?.message || error)}
        extra={[
          <Button type="primary" key="reload" onClick={() => window.location.reload()}>Reload</Button>,
          <Button key="home" onClick={() => { window.location.href = '/'; }}>Go to start page</Button>,
        ]}
      />
    );
  }
}

export default ErrorBoundary;
